import { render, staticRenderFns } from "./ReportsSidebar.vue?vue&type=template&id=2e5b2f0c&scoped=true"
import script from "./ReportsSidebar.vue?vue&type=script&lang=ts"
export * from "./ReportsSidebar.vue?vue&type=script&lang=ts"
import style0 from "./ReportsSidebar.vue?vue&type=style&index=0&id=2e5b2f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b2f0c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SidebarItem: require('/build/apps/legacy/components/Layout/Sidebar/SidebarItem.vue').default,ZTab: require('/build/apps/legacy/components/zeal/ZTab/ZTab.vue').default,SidebarItemGroup: require('/build/apps/legacy/components/Layout/Sidebar/SidebarItemGroup.vue').default,ZDivider: require('/build/apps/legacy/components/zeal/ZDivider/ZDivider.vue').default,FloatingButtonMobile: require('/build/apps/legacy/components/Common/FloatingButtonMobile.vue').default})
